module.exports = __webpack_public_path__ + "img/productSatellite_25.2d865310.png";